/**
 * 私用領域（PUA）文字の全除去
 *
 * 入力サニタイズ（ユーザー由来のマーカー偽装防止）と出力フェイルセーフ
 * （不整合マーカーの残留防止・スクリーンリーダー対策）の両方で使う単一実装。
 * BMP の U+E000〜F8FF に加え、補助面の PUA-A/B（U+F0000〜, U+100000〜）も対象。
 */

export const PUA_CODE_POINT_RANGES = [
  [0xe000, 0xf8ff],
  [0xf0000, 0xffffd],
  [0x100000, 0x10fffd],
] as const

const PUA_RANGE_SOURCE = PUA_CODE_POINT_RANGES.map(
  ([start, end]) => `${String.fromCodePoint(start)}-${String.fromCodePoint(end)}`,
).join("")
const PUA_ALL = new RegExp(`[${PUA_RANGE_SOURCE}]`, "gu")
const PUA_ANY = new RegExp(`[${PUA_RANGE_SOURCE}]`, "u")

/** テキストからPUA文字を全て除去する */
export function stripAllPua(text: string): string {
  return text.replace(PUA_ALL, "")
}

/** テキストがPUA文字を1文字でも含むか */
export function containsPua(text: string): boolean {
  return PUA_ANY.test(text)
}
